import request from '@/utils/http';

// 根据code从数据字典获取
export const getDictionaryDetailByCode = (params) => {
    return request({
        url: `/api-mdm/dictionaryDetail/dict`,
        method: 'get',
        params
    });
};
// 获取系统控制参数
export const getControlParam = (data) => {
    return request({
        url: `/api-bms-web/apApply/queryControlParam`,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    });
};

// 获取下载地址
export const getTempDownUrlByPath = (path) => {
    return request({
        url: `/api-bms-web/lcFileUpload/getTempDownUrlByPath?path=${path}`,
        method: 'post'
    });
};
/**
 * 从服务器获取字典数据并存储到sessionStorage中，同时返回下拉框选项数据对象。
 *
 * @param {string} optionNums - 逗号分隔的字典编码列表。
 * @returns {Promise} - 返回一个Promise对象，解析为字典数据对象（键为字典编码，值为对象，包含原始数据和转换后的选项数据）。
 *                       如果发生错误，Promise会被拒绝并返回一个Error对象。
 */
export async function getDictAndOptions(optionNums) {
    return new Promise((resolve, reject) => {
        if (optionNums) {
            const dictCodes = optionNums.split(',');
            const dictionaries = {};

            const handleDictionary = (dictCode, resObj) => {
                // 如果resObj是对象，则转换它；否则，保持原样（虽然非对象也不会进入map流程）
                const items = typeof resObj === 'object' && resObj !== null ?
                    Object.entries(resObj).map(([key, value]) => ({ value: key, label: value })) :
                    []; // 如果不是对象或null，则默认为空数组
                dictionaries[dictCode + '_OPTIONS'] = items;
                dictionaries[dictCode] = resObj;
            };

            dictCodes.forEach(dictCode => {
                const sessionData = sessionStorage.getItem(dictCode);
                if (sessionData) {
                    try {
                        const resObj = JSON.parse(sessionData);
                        handleDictionary(dictCode, resObj);
                    } catch (e) {
                        // eslint-disable-next-line no-console
                        console.error(`解析sessionStorage时出错 ${dictCode}:`, e);
                    }
                }
            });

            const missingCodes = Object.keys(dictionaries).filter(dictCode => !dictionaries[dictCode].length && dictCodes.includes(dictCode));
            if (!missingCodes || missingCodes.length < dictCodes.length) {
                const codes = dictCodes.join(',');
                getDictionaryDetailByCode({ dictCodes: codes }).then(res => {
                    if (res && res.code === '0') {
                        for (const dictCode in res.data) {
                            if (res.data.hasOwnProperty(dictCode)) {
                                handleDictionary(dictCode, res.data[dictCode]);
                                sessionStorage.setItem(dictCode, JSON.stringify(res.data[dictCode]));
                            }
                        }
                        resolve(dictionaries);
                    } else {
                        reject(new Error('从API获取字典失败'));
                    }
                }).catch(error => {
                    reject(error);
                });
            } else {
                resolve(dictionaries);
            }
        } else {
            reject(new Error('没有提供optionNums'));
        }
    });
}